<!-- 觉醒  觉醒境界技能-->
<template>
  <div class="TableContent TableContents_3">
    <p class="setctionTitle">觉醒境界技能</p>
    <ul class="SkillTable" name="phantom_skills">
      <mCommonItem
        class="pc-skill-item"
        :name="one['name']"
        :content="''"
        v-for="(one, o_index) in finalSkill.subSkills"
        :key="o_index"
        :src="jx_img(one.name)"
      >
        <template v-slot:name>
          <span class="pc-name"> {{ one.name }}<br />{{ one.lv }} </span>
        </template>
      </mCommonItem>
    </ul>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
const { jx_img } = inject('filters');

const props = defineProps({
  finalSkill: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
.SkillTable {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 20px;
}

.pc-skill-item {
  text-align: center;

}

.pc-name{
  white-space: nowrap;  
}
</style>